import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-218d4a3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-comments me-2" }),
    /*#__PURE__*/_createTextVNode("การสั่งการหรือเร่งรัดโครงการ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "แสดงข้อมูลการสั่งการหรือเร่งรัดโครงการจาก ร.นรม./รมต.นร.")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "input-group mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-coins" })
], -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "input-group mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-dot-circle" })
], -1))
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "badge rounded-pill bg-primary" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cubes me-2" }, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert-message" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "alert-heading" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-bell me-2" }),
    /*#__PURE__*/_createTextVNode("เกิดข้อผิดพลาด!")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "กรุณาติดต่อผู้ดูแลระบบเพื่อกำหนดหน้าที่รับผิดชอบก่อน")
], -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_VueSelect = _resolveComponent("VueSelect")!
  const _component_EnjoinTable = _resolveComponent("EnjoinTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.assigned)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFiscalYear) = $event)),
                          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fiscalYearChange && _ctx.fiscalYearChange(...args)))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fiscalYears, (fiscalYear) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: fiscalYear.id,
                              value: fiscalYear
                            }, _toDisplayString(fiscalYear.name), 9, _hoisted_8))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.selectedFiscalYear]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createVNode(_component_VueSelect, {
                          class: "form-control p-0",
                          modelValue: _ctx.selectedProvince,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedProvince) = $event)),
                          options: _ctx.provinces,
                          clearable: false,
                          label: "name",
                          placeholder: "กรุณาเลือกจังหวัด"
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ])
                  ]),
                  _createElementVNode("h4", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _hoisted_14,
                      _createTextVNode("การสั่งการ/เร่งรัดโครงการของ " + _toDisplayString(_ctx.selectedProvince?.name !== 'กรุงเทพมหานคร' ? 'จ.': '') + _toDisplayString(_ctx.selectedProvince?.name), 1)
                    ])
                  ]),
                  _createVNode(_component_EnjoinTable, {
                    "fiscal-year": _ctx.selectedFiscalYear,
                    province: _ctx.selectedProvince
                  }, null, 8, ["fiscal-year", "province"])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          ], 64))
    ])
  ]))
}